<!--
Copyright 2022 DigitalOcean

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->

<template>
    <div class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" aria-hidden="true">
            <path
                stroke="#3681f7" stroke-width="1.25" fill="none"
                d="M 2.649187 0.631203 L 21.221484 0.631203 C 22.340859 0.631203 23.248797 1.539141 23.248797 2.658516 L 23.248797 21.230812 C 23.248797 22.350187 22.340859 23.261234 21.221484 23.261234 L 2.649187 23.261234 C 1.529812 23.261234 0.618766 22.350187 0.618766 21.230812 L 0.618766 2.658516 C 0.618766 1.539141 1.529812 0.631203 2.649187 0.631203 Z M 2.649187 0.631203 "
                transform="matrix(1.256281,0,0,1.256281,0,0)"
            />
            <path
                stroke="#3681f7" stroke-width="1.25" fill="none"
                d="M 11.94 3.821422 C 11.94 3.821422 5.590656 8.469937 5.590656 13.221062 C 5.497375 15.549984 6.688266 17.745203 8.693812 18.936094 C 10.69625 20.130094 13.193078 20.130094 15.198625 18.936094 C 17.201062 17.745203 18.391953 15.549984 18.298672 13.221062 C 18.298672 8.640953 11.94 3.821422 11.94 3.821422 Z M 11.94 3.821422 "
                transform="matrix(1.256281,0,0,1.256281,0,0)"
            />
            <path
                fill="#3681f7"
                d="M 6.519531 5.289062 C 6.519531 5.96875 5.96875 6.519531 5.289062 6.519531 C 4.609375 6.519531 4.058594 5.96875 4.058594 5.289062 C 4.058594 4.609375 4.609375 4.058594 5.289062 4.058594 C 5.96875 4.058594 6.519531 4.609375 6.519531 5.289062 Z M 6.519531 5.289062 "
            />
            <path
                fill="#3681f7"
                d="M 25.96875 5.289062 C 25.96875 5.96875 25.417969 6.519531 24.734375 6.519531 C 24.054688 6.519531 23.503906 5.96875 23.503906 5.289062 C 23.503906 4.609375 24.054688 4.058594 24.734375 4.058594 C 25.417969 4.058594 25.96875 4.609375 25.96875 5.289062 Z M 25.96875 5.289062 "
            />
            <path
                fill="#3681f7"
                d="M 6.519531 24.734375 C 6.519531 25.417969 5.96875 25.96875 5.289062 25.96875 C 4.609375 25.96875 4.058594 25.417969 4.058594 24.734375 C 4.058594 24.054688 4.609375 23.503906 5.289062 23.503906 C 5.96875 23.503906 6.519531 24.054688 6.519531 24.734375 Z M 6.519531 24.734375 "
            />
            <path
                fill="#3681f7"
                d="M 25.96875 24.734375 C 25.96875 25.417969 25.417969 25.96875 24.734375 25.96875 C 24.054688 25.96875 23.503906 25.417969 23.503906 24.734375 C 23.503906 24.054688 24.054688 23.503906 24.734375 23.503906 C 25.417969 23.503906 25.96875 24.054688 25.96875 24.734375 Z M 25.96875 24.734375 "
            />
            <path
                stroke="#3681f7" stroke-width="1.25" fill="none"
                d="M 11.94 10.690031 L 11.94 16.131437 " transform="matrix(1.256281,0,0,1.256281,0,0)"
            />
            <path
                stroke="#3681f7" stroke-width="1.25" fill="none"
                d="M 14.660703 13.410734 L 9.219297 13.410734 " transform="matrix(1.256281,0,0,1.256281,0,0)"
            />
        </svg>
    </div>
</template>

<script>
    export default {
        name: 'StorageDropletIcon',
    };
</script>
